export const GLFeatureName = {

	'WEBGL_multi_draw': 'WEBGL_multi_draw',
	'WEBGL_compressed_texture_astc': 'texture-compression-astc',
	'WEBGL_compressed_texture_etc': 'texture-compression-etc2',
	'WEBGL_compressed_texture_etc1': 'texture-compression-etc1',
	'WEBGL_compressed_texture_pvrtc': 'texture-compression-pvrtc',
	'WEBGL_compressed_texture_s3tc': 'texture-compression-s3tc',
	'EXT_texture_compression_bptc': 'texture-compression-bc',
	'EXT_disjoint_timer_query_webgl2': 'timestamp-query',
	'OVR_multiview2': 'OVR_multiview2'

};
